// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_otpContainer__Yj9o\\+ {
  background-color: #0D0E11;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.styles_otpContainer__Yj9o\\+ > *:not(.styles_backgroundGlow__mM62F) {
  position: relative;
  z-index: 1;
}

.styles_backgroundGlow__mM62F {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.styles_backgroundSvg__oxE\\+X {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
}

.styles_contentBox__y5mF9 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  /* padding: 124px 24px 24px; */
  position: relative;
  z-index: 1;
  min-height: 100vh;
}

.styles_logoContainer__vLrji {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  height: 88px;
  overflow: hidden;
  position: relative;
}

.styles_logo__WvDNU {
  width: 88px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.styles_titleSection__-n69T {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 292px;
}

.styles_pageHeading__bGkw1 {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #F3F4F6;
  text-align: center;
  margin: 0;
}

.styles_phoneNumberSection__SXvvo {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
}

.styles_otpSentLabel__FN30Y {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #9396A3;
  margin: 0;
}

.styles_otpNo__6FK2Q {
  color: #9396A3;
}

.styles_editIconContainer__9cAP5 {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.styles_editIcon__rS5fZ {
  width: 20px;
  height: 20px;
  color: #8D93A8;
}

.styles_otpBlock__0yBTj {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 292px;
}

.styles_otpInputWrapper__QJo\\+n {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  padding-top: 8px;
}

.styles_otpInput__yDObb {
  width: 32px;
  height: 25px;
  border: none;
  border-bottom: 1px solid #4F5568;
  background: transparent;
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #9396A3;
  outline: none;
  padding: 0;
  margin: 0;
  -webkit-user-select: text;
  user-select: text;
  position: relative;
  z-index: 1;
}

.styles_otpInput__yDObb:focus {
  border-bottom-color: #9396A3;
}

.styles_otpInput__yDObb.styles_active__luQ3W {
  border-bottom-color: #9396A3;
}

.styles_otpInput__yDObb.styles_hideCaret__TjRc5 {
  caret-color: transparent;
}

.styles_otpCursor__VKkx9 {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #9396A3;
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  animation: styles_blink__E560A 1s infinite;
  pointer-events: none;
}

@keyframes styles_blink__E560A {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.styles_resendOtp__9gSs6 {
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 12px;
  gap: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: #C1C3CF;
  cursor: pointer;

}

.styles_resendOtp__9gSs6.styles_disabled__uy79X {
  color: #C1C3CF;
  cursor: not-allowed;
}

.styles_otpBtn__8qQhn {
  width: 100%;
  height: 56px;
  border-radius: 16px;
  background: #353945;
  color: #6A718B;
  border: none;
  outline: none;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
  margin-top: 0;
}

.styles_otpBtn__8qQhn:disabled {
  background: #353945;
  color: #6A718B;
  cursor: not-allowed;
}

.styles_otpBtn__8qQhn:not(:disabled) {
  background-color: #fff;
  color:#000;
  /* background: var(--Studio-gradient-CTA-Green-CTA, linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%));
  color: var(--referral-black, #000); */
}

.styles_declarationBlock__FQb4d {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  text-align: center;
  padding: 0;
  margin-top: 24px;
}

.styles_declarationLabel__R8R9Z {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #9396A3;
}

.styles_linkText__SwaQq {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  color: #F3F4F6;
  text-decoration: underline;
  text-underline-position: from-font;
}

.styles_declarationLabelOtp__nPHQp {
  display: flex;
  flex-direction: column;
  padding-top: 0;
}

/* Toast z-index to appear above logo */
.Toastify__toast-container {
  z-index: 1000 !important;
}

.Toastify__toast {
  z-index: 1001 !important;
}

`, "",{"version":3,"sources":["webpack://./src/pages/OtpScreen/styles.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,0CAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV;uCACqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".otpContainer {\n  background-color: #0D0E11;\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n}\n\n.otpContainer > *:not(.backgroundGlow) {\n  position: relative;\n  z-index: 1;\n}\n\n.backgroundGlow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.backgroundSvg {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n}\n\n.contentBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  /* padding: 124px 24px 24px; */\n  position: relative;\n  z-index: 1;\n  min-height: 100vh;\n}\n\n.logoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 88px;\n  height: 88px;\n  overflow: hidden;\n  position: relative;\n}\n\n.logo {\n  width: 88px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.titleSection {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n  width: 292px;\n}\n\n.pageHeading {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n  color: #F3F4F6;\n  text-align: center;\n  margin: 0;\n}\n\n.phoneNumberSection {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.otpSentLabel {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #9396A3;\n  margin: 0;\n}\n\n.otpNo {\n  color: #9396A3;\n}\n\n.editIconContainer {\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 8px;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.editIcon {\n  width: 20px;\n  height: 20px;\n  color: #8D93A8;\n}\n\n.otpBlock {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  width: 292px;\n}\n\n.otpInputWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: 40px;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n  padding-top: 8px;\n}\n\n.otpInput {\n  width: 32px;\n  height: 25px;\n  border: none;\n  border-bottom: 1px solid #4F5568;\n  background: transparent;\n  text-align: center;\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 100%;\n  color: #9396A3;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  -webkit-user-select: text;\n  user-select: text;\n  position: relative;\n  z-index: 1;\n}\n\n.otpInput:focus {\n  border-bottom-color: #9396A3;\n}\n\n.otpInput.active {\n  border-bottom-color: #9396A3;\n}\n\n.otpInput.hideCaret {\n  caret-color: transparent;\n}\n\n.otpCursor {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 100%;\n  color: #9396A3;\n  position: absolute;\n  top: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  animation: blink 1s infinite;\n  pointer-events: none;\n}\n\n@keyframes blink {\n  0%, 50% { opacity: 1; }\n  51%, 100% { opacity: 0; }\n}\n\n.resendOtp {\n  height: 44px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 20px;\n  border-radius: 12px;\n  gap: 8px;\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 14px;\n  color: #C1C3CF;\n  cursor: pointer;\n\n}\n\n.resendOtp.disabled {\n  color: #C1C3CF;\n  cursor: not-allowed;\n}\n\n.otpBtn {\n  width: 100%;\n  height: 56px;\n  border-radius: 16px;\n  background: #353945;\n  color: #6A718B;\n  border: none;\n  outline: none;\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n  cursor: pointer;\n  margin-top: 0;\n}\n\n.otpBtn:disabled {\n  background: #353945;\n  color: #6A718B;\n  cursor: not-allowed;\n}\n\n.otpBtn:not(:disabled) {\n  background-color: #fff;\n  color:#000;\n  /* background: var(--Studio-gradient-CTA-Green-CTA, linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%));\n  color: var(--referral-black, #000); */\n}\n\n.declarationBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  text-align: center;\n  padding: 0;\n  margin-top: 24px;\n}\n\n.declarationLabel {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #9396A3;\n}\n\n.linkText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 12px;\n  color: #F3F4F6;\n  text-decoration: underline;\n  text-underline-position: from-font;\n}\n\n.declarationLabelOtp {\n  display: flex;\n  flex-direction: column;\n  padding-top: 0;\n}\n\n/* Toast z-index to appear above logo */\n:global(.Toastify__toast-container) {\n  z-index: 1000 !important;\n}\n\n:global(.Toastify__toast) {\n  z-index: 1001 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpContainer": `styles_otpContainer__Yj9o+`,
	"backgroundGlow": `styles_backgroundGlow__mM62F`,
	"backgroundSvg": `styles_backgroundSvg__oxE+X`,
	"contentBox": `styles_contentBox__y5mF9`,
	"logoContainer": `styles_logoContainer__vLrji`,
	"logo": `styles_logo__WvDNU`,
	"titleSection": `styles_titleSection__-n69T`,
	"pageHeading": `styles_pageHeading__bGkw1`,
	"phoneNumberSection": `styles_phoneNumberSection__SXvvo`,
	"otpSentLabel": `styles_otpSentLabel__FN30Y`,
	"otpNo": `styles_otpNo__6FK2Q`,
	"editIconContainer": `styles_editIconContainer__9cAP5`,
	"editIcon": `styles_editIcon__rS5fZ`,
	"otpBlock": `styles_otpBlock__0yBTj`,
	"otpInputWrapper": `styles_otpInputWrapper__QJo+n`,
	"otpInput": `styles_otpInput__yDObb`,
	"active": `styles_active__luQ3W`,
	"hideCaret": `styles_hideCaret__TjRc5`,
	"otpCursor": `styles_otpCursor__VKkx9`,
	"blink": `styles_blink__E560A`,
	"resendOtp": `styles_resendOtp__9gSs6`,
	"disabled": `styles_disabled__uy79X`,
	"otpBtn": `styles_otpBtn__8qQhn`,
	"declarationBlock": `styles_declarationBlock__FQb4d`,
	"declarationLabel": `styles_declarationLabel__R8R9Z`,
	"linkText": `styles_linkText__SwaQq`,
	"declarationLabelOtp": `styles_declarationLabelOtp__nPHQp`
};
export default ___CSS_LOADER_EXPORT___;
